import Button from 'components/control/button';
import styles from './style.module.scss';
import { buildClassName } from 'utils/build-class-name';

type Props = {
  containerClassName?: string;
};

/**
 * CtaButtons component
 * @param containerClassName - The class name for the container
 * @returns The CtaButtons component
 */
const CtaButtons = ({ containerClassName }: Props) => {
  // We have to use <a> link on these wordpress pages, so animations can work on pull page reloads
  return (
    <div className={buildClassName(styles['cta-buttons'], containerClassName)}>
      <a href="/contact-us" rel="noopener noreferrer" aria-label="Contact us for more information">
        <Button theme="primary" label='Contact Us' />
      </a>
      <a href="/our-services" rel="noopener noreferrer" aria-label="Learn more about our services">
        <Button theme="secondary" label='Learn More' />
      </a>
    </div>
  );
};

export default CtaButtons;
